const GITHUB_USERNAME = "theeconomyflow";
const GITHUB_REPO = "purchasepalace";
const GITHUB_BRANCH = "main";
const GITHUB_TOKEN = "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";

const uploadImage = async (image) => {
  try {
    // 1. Convert image to Base64
    const fileBase64 = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = reject;
    });

    // 2. Create unique filename
    const fileName = `uploads/${Date.now()}-${image.name}`;

    // 3. GitHub API endpoint
    const url = `https://api.github.com/repos/${GITHUB_USERNAME}/${GITHUB_REPO}/contents/${fileName}`;

    // 4. Upload to GitHub
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        Authorization: `token ${GITHUB_TOKEN}`,
        "Content-Type": "application/json",
        Accept: "application/vnd.github.v3+json",
      },
      body: JSON.stringify({
        message: "Upload image",
        content: fileBase64,
        branch: GITHUB_BRANCH,
      }),
    });

    if (!response.ok) {
      throw new Error("GitHub upload failed");
    }

    const data = await response.json();

    // 5. RAW image URL (acts like Cloudinary secure_url)
    const rawUrl = `https://raw.githubusercontent.com/${GITHUB_USERNAME}/${GITHUB_REPO}/${GITHUB_BRANCH}/${fileName}`;

    // 6. RETURN Cloudinary-like response
    return {
      secure_url: rawUrl,
      url: rawUrl,
      public_id: fileName,
      github_response: data,
    };

  } catch (error) {
    console.error("Error uploading image:", error);
    return null;
  }
};

export default uploadImage;